import {MyopBindMessage, MyopBindReplayMessage} from "./BaseMessage";
import {MyopMessageKey} from "../common/MyopMessages";
import {RootRef} from "../common";
import {makeSerializable} from "../common/utils/serialization.ts";

const ReplayMessageKey = 'ExecuteScriptReplyMessage'

const functionBodyRegex = /(?:function\s*\w*\s*\([^)]*\)\s*\{([\s\S]*?)\}|(\([^)]*\)\s*=>\s*\{([\s\S]*?)\}))\s*$/;
const expressionBodyRegex = /\(\s*[^)]+\s*\)\s*=>\s*(.+)/;

export const stripFunction = (content: string) => {
    let match = content.match(functionBodyRegex);
    if (match) {
        return match[1] || match[3];
    } else {
        let match = content.match(expressionBodyRegex);
        if (match)
            return match[1].trim();
    }
}

export type scriptInputs = {
    [key: string]: string | number | boolean
} | {};

export type scriptVars<T> = {
    send: (data: T) => void;
    // completeStream: () => void;
    rootRef: RootRef;
    makeSerializable: typeof makeSerializable
}

export type extendedScriptVars<T, I> = {
    [K in keyof I]: I[K];
} & scriptVars<T>

export class ExecuteScriptMessage<T = any, I extends scriptInputs = any> extends MyopBindMessage<string, ExecuteScriptReplyMessage<T>> {

    replyMessageKey: MyopMessageKey = ReplayMessageKey;
    messageType = 'ExecuteScriptMessage';
    script: string = ''

    static replierKey = 'send';
    static completeStreamKey = 'completeStream';

    constructor(script: (vars: extendedScriptVars<T, I>) => T, handler: (message: ExecuteScriptReplyMessage<T>) => void = () => {
    }, public scriptInputs?: I) {
        super(handler);
        this.script = script.toString();

        //TODO: can be remove
        this.content = script.toString()
        this.content = stripFunction(this.content);
    }
}

export class ExecuteScriptReplyMessage<T = any> extends MyopBindReplayMessage<T> {

    messageType = ReplayMessageKey;

    constructor(public replayToHandler: string, public content: T) {
        super(replayToHandler);
    }
}
